module.exports = __webpack_public_path__ + "static/media/(H)-04-Capim-Dourado-bijuterias.4606c03d.jpg";